export const GET_ALL_USERS_REQUEST = "GET_ALL_USERS_REQUEST";
export const GET_ALL_USERS_SUCCESS = "GET_ALL_USERS_SUCCESS";
export const GET_ALL_USERS_FAILED = "GET_ALL_USERS_FAILED";

export const GET_USER_BY_ID_REQUEST = "GET_USER_BY_ID_REQUEST";
export const GET_USER_BY_ID_SUCCESS = "GET_USER_BY_ID_SUCCESS";
export const GET_USER_BY_ID_FAILED = "GET_USER_BY_ID_FAILED";

export const SUSPEND_USER_REQUEST = "SUSPEND_USER_REQUEST";
export const SUSPEND_USER_SUCCESS = "SUSPEND_USER_SUCCESS";
export const SUSPEND_USER_FAILED = "SUSPEND_USER_FAILED";

export const UNSUSPEND_USER_REQUEST = "UNSUSPEND_USER_REQUEST";
export const UNSUSPEND_USER_SUCCESS = "UNSUSPEND_USER_SUCCESS";
export const UNSUSPEND_USER_FAILED = "UNSUSPEND_USER_FAILED";

export const BAN_USER_REQUEST = "BAN_USER_REQUEST";
export const BAN_USER_SUCCESS = "BAN_USER_SUCCESS";
export const BAN_USER_FAILED = "BAN_USER_FAILED";

export const UNBAN_USER_REQUEST = "UNBAN_USER_REQUEST";
export const UNBAN_USER_SUCCESS = "UNBAN_USER_SUCCESS";
export const UNBAN_USER_FAILED = "UNBAN_USER_FAILED";

export const UPDATE_USER_REQUEST = "UPDATE_USER_REQUEST";
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS";
export const UPDATE_USER_FAILED = "UPDATE_USER_FAILED";

export const DELETE_USER_REQUEST = "DELETE_USER_REQUEST";
export const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS";
export const DELETE_USER_FAILED = "DELETE_USER_FAILED";

export const GET_READING_PROGRESS_BY_USER_REQUEST = "GET_READING_PROGRESS_BY_USERS_REQUEST";
export const GET_READING_PROGRESS_BY_USER_SUCCESS = "GET_READING_PROGRESS_BY_USERS_SUCCESS";
export const GET_READING_PROGRESS_BY_USER_FAILED = "GET_READING_PROGRESS_BY_USERS_FAILED";

export const UPDATE_USER_ROLE_REQUEST = "UPDATE_USER_ROLE_REQUEST";
export const UPDATE_USER_ROLE_SUCCESS = "UPDATE_USER_ROLE_SUCCESS";
export const UPDATE_USER_ROLE_FAILED = "UPDATE_USER_ROLE_FAILED";

export const SEARCH_USER_REQUEST = "SEARCH_USER_REQUEST";
export const SEARCH_USER_SUCCESS = "SEARCH_USER_SUCCESS";
export const SEARCH_USER_FAILED = "SEARCH_USER_FAILED";

export const FOLLOW_AUTHOR_REQUEST = "FOLLOW_AUTHOR_REQUEST";
export const FOLLOW_AUTHOR_SUCCESS = "FOLLOW_AUTHOR_SUCCESS";
export const FOLLOW_AUTHOR_FAILED = "FOLLOW_AUTHOR_FAILED";

export const UNFOLLOW_AUTHOR_REQUEST = "UNFOLLOW_AUTHOR_REQUEST";
export const UNFOLLOW_AUTHOR_SUCCESS = "UNFOLLOW_AUTHOR_SUCCESS";
export const UNFOLLOW_AUTHOR_FAILED = "UNFOLLOW_AUTHOR_FAILED";

export const GET_USER_PREFERENCES_REQUEST = "GET_USER_PREFERENCES_REQUEST";
export const GET_USER_PREFERENCES_SUCCESS = "GET_USER_PREFERENCES_SUCCESS";
export const GET_USER_PREFERENCES_FAILURE = "GET_USER_PREFERENCES_FAILURE";

export const GET_USER_FOLLOWERS_REQUEST = "GET_USER_FOLLOWERS_REQUEST";
export const GET_USER_FOLLOWERS_SUCCESS = "GET_USER_FOLLOWERS_SUCCESS";
export const GET_USER_FOLLOWERS_FAILURE = "GET_USER_FOLLOWERS_FAILURE";

export const GET_USER_FOLLOWING_REQUEST = "GET_USER_FOLLOWING_REQUEST";
export const GET_USER_FOLLOWING_SUCCESS = "GET_USER_FOLLOWING_SUCCESS";
export const GET_USER_FOLLOWING_FAILURE = "GET_USER_FOLLOWING_FAILURE";

export const GET_TOTAL_USERS_REQUEST = "GET_TOTAL_USERS_REQUEST";
export const GET_TOTAL_USERS_SUCCESS = "GET_TOTAL_USERS_SUCCESS";
export const GET_TOTAL_USERS_FAILED = "GET_TOTAL_USERS_FAILED";

export const GET_NEW_USERS_BY_MONTH_REQUEST = "GET_NEW_USERS_BY_MONTH_REQUEST";
export const GET_NEW_USERS_BY_MONTH_SUCCESS = "GET_NEW_USERS_BY_MONTH_SUCCESS";
export const GET_NEW_USERS_BY_MONTH_FAILED = "GET_NEW_USERS_BY_MONTH_FAILED";

export const GET_BLOCKED_USERS_REQUEST = "GET_BLOCKED_USERS_REQUEST";
export const GET_BLOCKED_USERS_SUCCESS = "GET_BLOCKED_USERS_SUCCESS";
export const GET_BLOCKED_USERS_FAILURE = "GET_BLOCKED_USERS_FAILURE";

export const BLOCK_USER_REQUEST = "BLOCK_USER_REQUEST";
export const BLOCK_USER_SUCCESS = "BLOCK_USER_SUCCESS";
export const BLOCK_USER_FAILURE = "BLOCK_USER_FAILURE";

export const UNBLOCK_USER_REQUEST = "UNBLOCK_USER_REQUEST";
export const UNBLOCK_USER_SUCCESS = "UNBLOCK_USER_SUCCESS";
export const UNBLOCK_USER_FAILURE = "UNBLOCK_USER_FAILURE";

export const GET_PROFILE_USER_REQUEST = "GET_PROFILE_USER_REQUEST";
export const GET_PROFILE_USER_SUCCESS = "GET_PROFILE_USER_SUCCESS";
export const GET_PROFILE_USER_FAILED = "GET_PROFILE_USER_FAILED";

export const CLEAR_PROFILE_USER = "CLEAR_PROFILE_USER";
